export default __webpack_public_path__ + "static/media/art-pro-slt-banner-2.0d3667bf.jpg";